import { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Sidebar, Menu, SidebarBrand, User, Name, Email } from './styled'
import { FaUsers, FaIndustry, FaFileAlt } from 'react-icons/fa'
import MenuItem from 'components/MenuItem'
import { Context } from 'contexts/context'

const menuItems = [
  { path: '/empresas', icon: <FaIndustry />, label: 'Empresas' },
  { path: '/admin', icon: <FaUsers />, label: 'Admin' },
  { path: '/report-task', icon: <FaFileAlt />, label: 'Relatório Task'}
]

const Component = () => {
  const { toggle, user } = useContext(Context)
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    setInitialized(true)
  }, [])

  return (
    <Sidebar
      className={`
                ${toggle ? 'open' : 'closed'}
                ${toggle ? 'menu-open' : 'menu-closed'}
                ${!initialized ? 'no-transition' : ''}
            `}
    >
      <Link to="/">
        <SidebarBrand className={toggle ? 'open' : 'closed'}>
          <img className="logo" src="/logo-dato.png" alt="Dato Tecnologia" />
          <img className="logo-mini" src="/logo-dato.png" alt="Dato Tecnologia" />
        </SidebarBrand>
      </Link>
      <User to="/profile">
        <img src={user.file_url ? `${process.env.REACT_APP_URL_API}/${user.file_url}` : '/user.svg'} alt="analyticdbi" />
        <div className={`${toggle ? 'open' : 'closed'}`}>
          <Name>{user.name}</Name>
          <Email>{user.email}</Email>
        </div>
      </User>
      <Menu>
        {menuItems.map((item, index) => (
          <MenuItem
            key={index}
            path={item.path}
            icon={item.icon}
            label={item.label}
          />
        ))}
      </Menu>
    </Sidebar>
  )
}

export default Component
